import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import styles from './_ssn-input-group.module.scss';
import { getWordingForLanguage } from '../../../Helpers/LanguageDictionary';
import { TextBox, TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { isNotNil } from 'ramda';

export interface SSNInputGroupProps {
  selectedLanguageId: string;
  ssnLastFour: string | undefined;
  canLogin: boolean;
  loggingIn: boolean;
  onChange: (value: string) => void;
  onUseAlternateLogin: () => void;
  onLogin: () => void;
}

const SSNInputGroup = (props: SSNInputGroupProps) => {
  //return child component
  return (
    <div className={styles.ssnContainer}>
      <TextBox
        autoFocus={true}
        value={props.ssnLastFour ?? ''}
        placeholder={getWordingForLanguage('ssnPlaceholder', props.selectedLanguageId)}
        onChange={(e: TextBoxChangeEvent) => {
          // strip non-digits and trim to 4 characters before passing to the parent component
          if (isNotNil(e.target.value)) {
            props.onChange((e.target.value as string).replace(/\D/g, '').slice(0, 4));
          }
        }}
        maxLength={4}
        type='tel'
        inputMode='numeric'
        pattern='[0-9]*'
        fillMode={'outline'}
        style={{ marginBottom: '10px', maxWidth: '100px' }}
        onKeyDown={(e) => {
          // if enter key, call onLogin if user can login
          if (e.key === 'Enter' && props.canLogin) {
            props.onLogin();
          }
        }}
      />
      <Button
        themeColor={'primary'}
        style={{ marginTop: '0', width: '100%' }}
        disabled={!props.canLogin || props.loggingIn}
        onClick={() => props.onLogin()}>
        {props.loggingIn === true ? getWordingForLanguage('loggingIn', props.selectedLanguageId) : getWordingForLanguage('login', props.selectedLanguageId)}
      </Button>

      <div className={styles.actionRow}>
        <Button
          fillMode="outline"
          onClick={() => props.onUseAlternateLogin()}
          style={{
            borderColor: 'rgba(0, 0, 0, 0.38)',
            textTransform: 'none',
            width: '100%'
          }}
        >
          {getWordingForLanguage('loginWithNameAndBirthday', props.selectedLanguageId)}
        </Button>

      </div>
    </div>
  );
};

export default SSNInputGroup;
